import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Confirmation from "./Confirmation";

function BookingForm({ course, onClose }) {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [bookingData, setBookingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

const onSubmit = async (data) => {
  setLoading(true);
  setError(null);

  try {
    const response = await fetch(
      "https://calenderbackend-kkya.onrender.com/calenderbooking",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...data,
          course: course["COURSE/ PROGRAMME"],
        }),
      }
    );

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Failed to submit the booking.");
    }

    const result = await response.json();
    setBookingData(result); // better to use backend response
  } catch (err) {
    console.error("Error submitting booking:", err);
    setError(err.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};


  if (bookingData) {
    return <Confirmation data={bookingData} course={course} onClose={onClose} />;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-2xl font-semibold mb-4">Book: {course["COURSE/ PROGRAMME"]}</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label className="block text-gray-700">Bank Name</label>
            <input
              type="text"
              {...register("bankName", { required: true })}
              className={`w-full px-3 py-2 border ${errors.bankName ? "border-red-500" : "border-gray-300"} rounded`}
            />
            {errors.bankName && <span className="text-red-500 text-sm">This field is required</span>}
          </div>

          <div className="mb-4">
  <label className="block text-gray-700">Number of Participants</label>
  <input
    type="number"
    placeholder="number of participants optional"
    {...register("participants", { min: 1 })}
    className={`w-full px-3 py-2 border ${
      errors.participants ? "border-red-500" : "border-gray-300"
    } rounded`}
  />
  {errors.participants && <span className="text-red-500 text-sm">Enter a valid number</span>}
</div>


          <div className="mb-4">
            <label className="block text-gray-700">Phone Number</label>
            <input
              type="tel"
              {...register("phone", { required: true, pattern: /^[0-9]{10,15}$/ })}
              className={`w-full px-3 py-2 border ${errors.phone ? "border-red-500" : "border-gray-300"} rounded`}
            />
            {errors.phone && <span className="text-red-500 text-sm">Enter a valid phone number</span>}
          </div>

          <div className="mb-4">
            <label className="block text-gray-700">Email</label>
            <input
              type="email"
              {...register("email", { required: true, pattern: /^\S+@\S+$/i })}
              className={`w-full px-3 py-2 border ${errors.email ? "border-red-500" : "border-gray-300"} rounded`}
            />
            {errors.email && <span className="text-red-500 text-sm">Enter a valid email</span>}
          </div>

          <div className="mb-4">
            <label className="block text-gray-700">Job Title</label>
            <input
              type="text"
              {...register("jobTitle", { required: true })}
              className={`w-full px-3 py-2 border ${errors.jobTitle ? "border-red-500" : "border-gray-300"} rounded`}
            />
            {errors.jobTitle && <span className="text-red-500 text-sm">This field is required</span>}
          </div>

          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 mr-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default BookingForm;
